const pagination = () => ({
    limit: 10,
    offset: 0,
    length: 0,
    pageNumber: 0,
});

export default pagination;
